export interface Override {
  module: string
  name: string
  signature: string
}

export interface ClassDescription {
  name: string
  signature: string
  extends: string
}

export interface ClassOverrides {
  class: ClassDescription
  methods: Record<string, Override>
  properties: Record<string, Override>
  constants: Record<string, Override>
}

export interface ShopOverridesByClass {
  [key: string]: ClassOverrides
}

export enum ProductCompatibilityTag {
  PERFECT_MATCH = 'perfect_match',
  COMPATIBLE = 'compatible',
  MERGING_FUNCTION_REQUIRED = 'merging_function_required',
  TECHNICAL_SKILLS_REQUIRED = 'technical_skills_required',
}

export interface PhpVersionRequirement {
  minPhpVersion: string | undefined
  isOfficiallyTested: boolean
}

export interface PhpCompatibilityInfo {
  shopPhpVersion: string
  recommended?: string
  isVerified: boolean
  supportedRange?: {
    min: string
    max: string
  }
  isCompliance: boolean
  isCompatible: boolean
}